import { Toaster } from 'sonner';

/**
 * ToastProvider — wraps sonner's Toaster component with project-consistent styling.
 * Place this component once in the app tree (App.tsx) to enable toast notifications
 * across all pages. Use `toast()` from sonner anywhere to show notifications.
 *
 * Styled to match the cozy/kawaii theme: top-right position, Nunito font,
 * warm pastel colors, rounded corners.
 */
export default function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      expand={false}
      richColors
      closeButton
      duration={4000}
      toastOptions={{
        style: {
          fontFamily: "'Nunito', system-ui, sans-serif",
          borderRadius: '1rem',
          padding: '1rem',
        },
      }}
    />
  );
}
